import { render, staticRenderFns } from "./Resize.vue?vue&type=template&id=65bf0e46&"
import script from "./Resize.vue?vue&type=script&lang=ts&"
export * from "./Resize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports